// extracted by mini-css-extract-plugin
export default {"errorMessage":"errorMessage__errorMessage--Kak2w"};